import type { CSSProperties } from 'react'
import { C } from '../theme'
import { ContactForm } from './ContactForm'
import { PinIcon } from './icons'
import { useContent } from '../content/ContentContext'
import { mailHref, mapsLinks, telHref } from '../content/derive'

const detailLabel: CSSProperties = {
  fontSize: 12.5, fontWeight: 700, letterSpacing: '.14em', textTransform: 'uppercase',
  color: '#9fb4d6', marginBottom: 6,
}
const divider: CSSProperties = { height: 1, background: 'rgba(255,255,255,.12)' }

export function Contact() {
  const { home, settings } = useContent()
  const section = home.contactSection ?? {}
  const contact = settings.contact ?? {}
  const maps = mapsLinks(settings)
  const tel = telHref(contact.phone)
  const mail = mailHref(contact.email)
  const phoneLine = [contact.phoneDisplay, contact.contactName].filter(Boolean).join(' · ')

  return (
    <section id="contacto" aria-label="Contacto y ubicación" className="sec" style={{ padding: '96px 40px 104px', background: C.navy, color: '#e7edf6' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto 52px' }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.goldSoft, marginBottom: 16 }}>
            {section.eyebrow}
          </div>
          <h2 className="section-title" style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 44, lineHeight: 1.1, margin: 0, color: '#fff', letterSpacing: '-.01em' }}>
            {section.title}
          </h2>
          {section.body && (
            <p style={{ fontSize: 16.5, lineHeight: 1.7, color: 'rgba(231,237,246,.86)', margin: '14px 0 0' }}>{section.body}</p>
          )}
        </div>

        <div className="stack" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'start' }}>
          {/* Map + details */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            {maps.embed && (
              <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(255,255,255,.12)', boxShadow: '0 14px 34px rgba(0,0,0,.28)', lineHeight: 0 }}>
                <iframe
                  title="Mapa — La Casita de Dios"
                  src={maps.embed}
                  width="100%"
                  height="300"
                  style={{ border: 0, display: 'block' }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            )}
            {maps.directions && section.directionsLabel && (
              <a
                className="btn"
                href={maps.directions}
                target="_blank"
                rel="noopener"
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 10, background: C.red, color: '#fff', fontWeight: 700, fontSize: 15, padding: '15px 24px', borderRadius: 3, textDecoration: 'none', boxShadow: '0 8px 22px rgba(193,39,45,.32)' }}
              >
                <PinIcon size={18} /> {section.directionsLabel}
              </a>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
              {(contact.locationLine1 || contact.locationLine2) && (
                <div>
                  <div style={detailLabel}>Ubicación</div>
                  <a href={maps.view} target="_blank" rel="noopener" style={{ fontSize: 17, color: '#fff', lineHeight: 1.5, textDecoration: 'none' }}>
                    {contact.locationLine1}
                    {contact.locationLine2 && (
                      <>
                        <br />
                        {contact.locationLine2}
                      </>
                    )}
                  </a>
                </div>
              )}
              {tel && (
                <>
                  <div style={divider} />
                  <div>
                    <div style={detailLabel}>Teléfono</div>
                    <a href={tel} style={{ fontSize: 17, color: '#fff', textDecoration: 'none' }}>{phoneLine}</a>
                  </div>
                </>
              )}
              {mail && (
                <>
                  <div style={divider} />
                  <div>
                    <div style={detailLabel}>Correo</div>
                    <a href={mail} style={{ fontSize: 17, color: '#fff', textDecoration: 'none' }}>{contact.email}</a>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Form */}
          <ContactForm />
        </div>
      </div>
    </section>
  )
}
